import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box,Card, CardContent, Typography, Grid, CardActionArea } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserFriends, faStore } from '@fortawesome/free-solid-svg-icons';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/constants';
import BackButton from '../../components/BackButton';

const cardData = [
  {
    title: 'Customer Notification',
    icon: faUserFriends,
    path: '/notification/customer-notification',
    moduleCode: 8210, // You can adjust these module codes as needed
  },
  {
    title: 'Merchant Notification',
    icon: faStore,
    path: '/notification/shop-notification',
    moduleCode: 8211, // You can adjust these module codes as needed
  },
];

const ManageNotification = () => {
  const [userLevel, setUserLevel] = useState(null);
  const [userModules, setUserModules] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserLevel(decodedToken.level);
      verifyUserModules(decodedToken);
    }
  }, []);

  const verifyUserModules = async (decodedToken) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/privileges/modules/${decodedToken.userId}`);
      setUserModules(response.data.modules || []);
    } catch (error) {
      console.error('Error fetching user privileges:', error);
    }
  };

  const hasAccess = (card) => {
    // If userLevel is 1 (super admin), show all contents
    if (userLevel === 1) {
      return true;
    }
    // Otherwise, verify if user has this module
    if (card.moduleCode && userModules.includes(card.moduleCode)) {
      return true;
    }
    return false;
  };

  const handleCardClick = (card) => {
    if (hasAccess(card)) {
      navigate(card.path);
    } else {
      setErrorMessage('You are not allowed to use this feature.');
    }
  };

  return (
    <>
     <Box sx={{ position: 'relative', padding: 2 }}>
                  {/* Place BackButton outside the Grid */}
                  <BackButton />
                  <br/>  <br/>
      <Grid container spacing={3} alignItems="center">
        {cardData.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.title}>
            <Card
              elevation={3}
              sx={{
                maxWidth: 225,
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '& .MuiTypography-root': {
                    color: 'white !important',
                  },
                  '& .fa-icon': {
                    color: 'white !important',
                  },
                },
              }}
            >
              <CardActionArea onClick={() => handleCardClick(card)}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={card.icon}
                    size="5x"
                    className="fa-icon"
                    style={{ color: 'orange' }}
                  />
                  <Typography gutterBottom variant="h5" component="div" sx={{ marginTop: 2 }}>
                    {card.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      {errorMessage && (
        <Typography variant="h6" color="error" align="center" sx={{ marginTop: 2 }}>
          {errorMessage}
        </Typography>
      )}
      </Box>
    </>
  );
};

export default ManageNotification;